module.exports = __webpack_public_path__ + "fa-solid-900.422cfe2813b03d900c10310a4b384100.hashedasset.ttf";